import templateUrl from 'emun.medialibrary/medialibrary.htm'
import controller from 'emun.medialibrary/medialibrary.controller'

let MediaLibrary = {
	bindings: {
    },
    controller,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

export default MediaLibrary;